/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'filter-circle-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16M3.5 5h9a.5.5 0 010 1h-9a.5.5 0 010-1M5 8.5a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5m2 3a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5"/>',
    },
});
